import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import dayjs from 'dayjs';
import { ConfirmationService, FilterService, PrimeNGConfig } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { SpinnerComponent } from './core/components/spinner/spinner.component';
import { AppLayoutModule } from './core/layout/app.layout.module';

import * as i18nData from '../assets/i18n/it.json';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    AppLayoutModule,
    ToastModule,
    SpinnerComponent,
    ConfirmDialogModule,
    MessagesModule,
  ],
  providers: [ConfirmationService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  filterService = inject(FilterService);
  primeNGConfig = inject(PrimeNGConfig);
  title = 'app';

  ngOnInit(): void {
    this.primeNGConfig.setTranslation(i18nData);

    this.filterService.register('customDateRange', (value: Date, filter: Date[]): boolean => {
      if (filter && filter[0] && filter[1]) {
        const startDate = dayjs(filter[0]).startOf('day');
        const endDate = dayjs(filter[1]).endOf('day');
        const valueDate = dayjs(value);
        return valueDate.isAfter(startDate) && valueDate.isBefore(endDate);
      }
      return true;
    });
  }
}
